const mEditionInfo = {
  mEditionInfo: {
    academy: 'Academia',
    account: 'Mi Cuenta',
    asset: 'Curso',
    billing: 'Gestión',
    map: 'Mapa',
    product: 'Producto',

    actions: {
      goBack: 'volver atrás'
    },

    title: {
      currency: 'MONEDA'
    }
  }
}

export default mEditionInfo
